// import i18n from "i18next";
// import LanguageDetector from "i18next-browser-languagedetector";
// import { initReactI18next } from "react-i18next";

// i18n
//   .use(LanguageDetector)
//   .use(initReactI18next)
//   .init({
//       resources:{
//           en: {
//               translations: {
//                 "Overview dashboard": "Overview dashboard",
//               }
//           },
//           ar: {"Copyright": "Copyright Hindi"}
//       },
//       fallbackLng: "en",
//     debug: false,

//     // have a common namespace used around the full app
//     ns: ["translations"],
//     defaultNS: "translations",

//     keySeparator: false, // we use content as keys

//     interpolation: {
//       escapeValue: false
//     }
//   });

//   export default i18n;
// i18n.js

import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        seasonal_lulc: "Seasonal LULC",
        sowing_progress: "Sowing Progress",
        crop_health: "Crop Health",
        crop_acreage: "Crop Acreage",
        "crop-acerage": "crop-acerage",
        harvest_progress: "Harvest Progress",
        yield: "Yield",
        summary: "Summary",
        gt_dashboard: "GT Dashboard",
        Rabi: "Rabi",
        Kharif: "Kharif",
        "Select District": "Select District",
        "Select Block": "Select Block",
        "Select GP": "Select GP",
        Type: "Type",
        "Select Season": "Select Season",
        "Select Language": "Select Language",
        English: "English",
        Hindi: "Hindi",
        "Select Crop": "Select Crop",
        Paddy: "Paddy",
        Maize: "Maize",
        Jowar: "Jowar",
        Bajra: "Bajra",
        Groundnut: "Groundnut",
        Soybean: "Soybean",
        Others: "Others",
        Wheat: "Wheat",
        Mustard: "Mustard",
        Potato: "Potato",
        Pea: "Pea",
        Peas: "Peas",
        Others: "Others",
        Lentil: "Lentil",
        Gram: "Gram",
        Onion: "Onion",
        All: "All",
        "Crop Land Area (in Ha)": "Crop Land Area (in Ha)",
        "Waste Land Area (in Ha)": "Waste Land Area (in Ha)",
        "Forest Area (in Ha)": "Forest Area (in Ha)",
        "Plantation Area (in Ha)": "Plantation Area (in Ha)",
        "Built Up Area (in Ha)": "Built Up Area (in Ha)",
        "Water Bodies (in Ha)": "Water Bodies (in Ha)",
        "Fallow Area (in Ha)": "Fallow Area (in Ha)",
        "Other Area (in Ha)": "Other Area (in Ha)",
        "Total Sown Area (in Ha)": "Total Sown Area (in Ha)",
        "Paddy Harvested": "Paddy Harvested",
        "Paddy Standing": "Paddy Standing",
        "Maize Harvested": "Maize Harvested",
        "Maize Standing": "Maize Standing",
        "Jowar Harvested": "Jowar Harvested",
        "Jowar Standing": "Jowar Standing",
        "Bajra Harvested": "Bajra Harvested",
        "Bajra Standing": "Bajra Standing",
        "Pea Harvested": "Pea Harvested",
        "Pea Standing": "Pea Standing",
        "Soybean Harvested": "Soybean Harvested",
        "Soybean Standing": "Soybean Standing",
        Good: "Good",
        Average: "Average",
        Poor: "Poor",
        "Wheat Harvested": "Wheat Harvested",
        "Wheat Standing": "Wheat Standing",
        "Potato Standing": "Potato Standing",
        "Potato Harvested": "Potato Harvested",
        "Lentil Harvested": "Lentil Harvested",
        "Lentil Standing": "Lentil Standing",
        "Onion Harvested": "Onion Harvested",
        "Onion Standing": "Onion Standing",
        "Gram Harvested": "Gram Harvested",
        "Gram Standing": "Gram Standing",
        "Mustard Harvested": "Mustard Harvested",
        "Mustard Standing": "Mustard Standing",
        GroundNut: "मूंगफली ",
        Harvested: "Harvested",
        Standing: "Standing",
        first: "first",
        second: "second",
        First: "First",
        Second: "Second",
        Third: "Third",
        "Technology Based Command Center for Crop Acreage and Yield Monitoring":
          "Technology Based Command Center for Crop Acreage and Yield Monitoring",
        "Kharif Total Sown Area": "Kharif Total Sown Area",
        "Rabi Total Sown Area": "Rabi Total Sown Area",
        "First Harvested": "First Harvested",
        "Second Harvested": "Second Harvested",
        "Third Harvested": "Third Harvested",
        "First Standing": "First Standing",
        "Second Standing": "Second Standing",
        "Third Standing": "Third Standing",
        "Sown Area": "Sown Area",
        "Crop Health": "Crop Health",
        "Crop Harvest": "Crop Harvest",
        Acreage: "Acreage",
        "Acreage First": "Acreage First",
        "Acreage Second": "Acreage Second",
        "Select Estimate": "Select Estimate",
        "Technology Based Command Center for Crop Acreage and Yield Monitoring":
          "Technology Based Command Center for Crop Acreage and Yield Monitoring",
        "Survey No": "Survey No",
        District: "District",
        "Crop Name": "Crop Name",
        "Crop Variety": "Crop Variety",
        "Created By": "Created By",
        "Created Date": "Created Date",
        "Variety Name": "Variety Name",
        "View Detail": "View Detail",
        Zaid: "Zaid",
        project_name_en:
          "Pilot Study on 360 degree Analytics of Olive Groves Value Chain using Strong AI Frameworks, Portugal",
        "Quick Access": "Quick Access",
      },
    },
    hi: {
      translation: {
        seasonal_lulc: "मौसमी LULC",
        sowing_progress: "बोआई की प्रगति",
        crop_health: "फसल स्वास्थ्य",
        crop_acreage: "फसल क्षेत्रफल",
        "crop-acerage": "फसल क्षेत्रफल",
        "Crop Acreage": "फसल क्षेत्रफल",
        harvest_progress: "कटाई की प्रगति",
        yield: "पैदावार",
        Yield: "पैदावार",
        summary: "सारांश",
        gt_dashboard: "जीटी डैशबोर्ड",
        Rabi: "रबी",
        Kharif: "खरीफ",
        "Select District": "जिला चुनें",
        "Select Block": "ब्लॉक चुनें",
        "Select GP": "ग्रामपंचायत चुनें",
        Type: "प्रकार",
        "Select Season": "सीजन चुनें",
        "Select Language": "भाषा चुने",
        English: "अंग्रेज़ी",
        Hindi: "हिंदी",
        "Select Crop": "फसल चुने",
        Paddy: "धान",
        Maize: "मक्का",
        Jowar: "ज्वार",
        Bajra: "बाजरा",
        Groundnut: "मूंगफली",
        Soybean: "सोयाबीन",
        Others: "अन्य",
        Wheat: "गेहूं",
        Mustard: "सरसों",
        Potato: "आलू",
        Pea: "मटर",
        Lentil: "मसूर",
        Gram: "चना",
        Onion: "प्याज",
        All: "सभी",
        "Crop Land Area (in Ha)": "फसल भूमि क्षेत्र (हेक्टेयर में)",
        "Waste Land Area (in Ha)": "बंजर भूमि क्षेत्र (हेक्टेयर में)",
        "Forest Area (in Ha)": "वन क्षेत्र (हेक्टेयर में)",
        "Plantation Area (in Ha)": "वृक्षारोपण क्षेत्र (हेक्टेयर में)",
        "Built Up Area (in Ha)": "निर्मित क्षेत्र (हेक्टेयर में)",
        "Water Bodies (in Ha)": "जल निकाय (हेक्टेयर में)",
        "Fallow Area (in Ha)": "परती क्षेत्र (हेक्टेयर में)",
        "Other Area (in Ha)": "अन्य क्षेत्र (हेक्टेयर में)",
        "Total Sown Area (in Ha)": "कुल बोया गया क्षेत्र (हेक्टेयर में)",
        "Paddy Harvested": "धान Harvested",
        "Paddy Standing": "धान Standing",
        "Maize Harvested": "मक्का Harvested",
        "Maize Standing": "मक्का Standing",
        "Jowar Harvested": "ज्वार Harvested",
        "Jowar Standing": "ज्वार Standing",
        "Bajra Harvested": "बाजरे Harvested",
        "Bajra Standing": "बाजरा Standing",
        "Pea Harvested": "मटर Harvested",
        "Pea Standing": "मटर Standing",
        "Soybean Harvested": "सोयाबीन Harvested",
        "Soybean Standing": "सोयाबीन Standing",
        Good: "अच्छा",
        Average: "औसत",
        Poor: "खराब",
        "Wheat Harvested": "गेहूं Harvested",
        "Wheat Standing": "गेहूं Standing",
        "Potato Standing": "आलू Standing",
        "Potato Harvested": "आलू Harvested",
        "Lentil Harvested": "मसूर फसल",
        "Lentil Standing": "मसूर Standing",
        "Onion Harvested": "प्याज Harvested",
        "Onion Standing": "प्याज Standing",
        "Gram Harvested": "चने Harvested",
        "Gram Standing": "चने Standing",
        "Mustard Harvested": "सरसों Harvested",
        "Mustard Standing": "सरसों Standing",
        "Peas Standing": "मटर Standing",
        "Peas Harvested": "मटर Harvested",
        Others: "अन्य",
        "Others Standing": "अन्य Standing",
        "Others Harvested": "अन्य Harvested",
        "GroundNut Harvested": "मूंगफली Harvested",
        "GroundNut Standing": "मूंगफली Standing",
        Standing: "फ़सल खडी है",
        Harvested: "फ़सल कटाई",
        first: "प्रथम",
        second: "द्वितीय",
        First: "प्रथम",
        Second: "द्वितीय",
        Third: "तीसरा",
        "First Estimated": "प्रथम अनुमानित",
        "Second Estimated": "द्वितीय अनुमानित",
        "in Ha": "हेक्टेयर में",
        "Technology Based Command Center for Crop Acreage and Yield Monitoring":
          "फसल क्षेत्रफल और उपज की निगरानी के लिए प्रौद्योगिकी आधारित कमांड सेंटर",
        "Kharif Total Sown Area": "खरीफ कुल बोया गया क्षेत्र",
        "Rabi Total Sown Area": "रबी कुल बोया गया क्षेत्र",
        "First Harvested": "प्रथम कटाई",
        "Second Harvested": "द्वितीय कटाई",
        "Third Harvested": "तीसरा कटाई",
        "First Standing": "प्रथम खडी फसल",
        "Second Standing": "द्वितीय खडी फसल",
        "Third Standing": "तीसरा खडी फसल",
        "Sown Area": "बोया गया क्षेत्र",
        "Crop Health": "फसल स्वास्थ्य",
        "Crop Harvest": "फसल कटाई",
        Acreage: "एकड़",
        "Acreage Second": "एकड़ प्रथम",
        "Acreage First": "एकड़ द्वितीय",
        "Select Estimate": "अनुमान चुनें",
        "Survey No": "सर्वेक्षण संख्या",
        District: "जिला",
        "Crop Name": "फसल का नाम",
        "Crop Variety": "फसल की विविधता",
        "Created By": "के द्वारा बनाई गई",
        "Created Date": "सृजित दिनांक",
        "Variety Name": "किस्म का नाम",
        "View Detail": "विस्तार से देखें",
        Zaid: "ज़ैद",
      },
    },
    "pt-PT": {
      translation: {
        gt_dashboard: "Painel GT",
        Rabi: "Rabi",
        Kharif: "Kharif",

        "Select District": "Selecionar Distrito",
        "Select Block": "Selecionar Bloco",
        "Select GP": "Selecionar GP",
        Type: "Tipo",
        "Select Season": "Selecionar Época", // Estação → Época (correct for agriculture)
        "Select Language": "Selecionar Idioma",
        English: "Inglês",
        Hindi: "Hindi",
        "Select Crop": "Selecionar Cultura",

        Third: "Terceiro",

        "Technology Based Command Center for Crop Acreage and Yield Monitoring":
          "Centro de Comando Baseado em Tecnologia para Monitorização da Área e Produção Agrícola",

        FPO: "Clusters",
        Farmers: "Agricultores",
        "Cluster Map": "Mapa de Clusters",
        "Land Holding": "Posse de Terra",

        project_name_pt:
          "Estudo Piloto sobre Análise de 360 Graus da Cadeia de Valor do Olival utilizando Estruturas Avançadas de IA, Portugal",

        "Quick Access": "Acesso Rápido",
        Clusters: "Agrupamentos",
        Commodities: "Produtos",

        e_mandi: "E-Mandi",
        live_mandi_prices: "Preços de Mandi em Tempo Real", // "Ao vivo" → more natural as "em tempo real"
        employees: "Funcionários",
        aggregation: "Agregação",

        "View Details": "Ver Detalhes",
        "Created on": "Criado em",
        Crops: "Culturas",

        Analytics: "Análises",
        Clear: "Limpar",

        "Season 1 (July - December)": "Época 1 (Julho - Dezembro)",

        "Satellite Indices": "Índices de Satélite",
        "Weather Indices": "Índices Meteorológicos",
        "Time Series": "Séries Temporais",
        "Total Farmers": "Total de Agricultores",
        Search: "Pesquisar",

        "Add Farmer": "Adicionar",
        "Upload Farmers": "Carregar",
        "Sample CSV": "CSV de Exemplo",
        "Upload CSV": "Carregar CSV",
        Download: "Descarregar",
        CSV: "CSV",
        Geojson: "GeoJSON",
        Assign: "Atribuir",

        Name: "Nome",
        "Onboarding Date": "Data de Registo", // "Inscrição" sounds like signing up for a service; "Registo" is correct
        Mobile: "Telemóvel",
        Gender: "Género",
        Age: "Idade",
        Category: "Categoria",
        "Declared Landholding": "Posse de Terra Declarada",
        "Farm Score": "Pontuação Agrícola", // "Propriedade" → farm score refers to agricultural scoring
        ACS: "ACS",
        "State Name": "Nome do Estado",
        "District Name": "Nome do Distrito",
        Action: "Ação",

        "Marginal (Less than 2.5 acres)": "Marginal (Menos de 2,5 acres)",
        "Small (2.5–5 acres)": "Pequeno (2,5–5 acres)",
        "Semi Medium (5–10 acres)": "Semi-Médio (5–10 acres)",
        "Medium (10–25 acres)": "Médio (10–25 acres)",
        "Large (25 acres and above)": "Grande (25 acres ou mais)",

        Male: "Masculino",
        Female: "Feminino",
        Others: "Outros",

        "Created At": "Criado em",
        "Updated At": "Atualizado em",

        NDVI: "NDVI",
        NDMI: "NDMI",
        NDRE: "NDRE",
        NDWI: "NDWI",
        CIG: "CIG",
        CIRedEdge: "CIRedEdge",
        RVI: "RVI",

        min_temperature: "Temperatura Mínima",
        max_temperature: "Temperatura Máxima",
        precipitation: "Precipitação",
        wind_speed: "Velocidade do Vento",
        relative_humidity: "Humidade Relativa",
        solar_radiation: "Radiação Solar",

        value: "Valor",
        Date: "Data",
        mean: "Média",

        "Farmer Level Data": "Dados do Produtor",
        "Select Municipality": "Selecionar Município",
        "Select Parish": "Selecionar Freguesia",
        "Search by Name": "Pesquisar por Nome",
        "Baseline Assessment": "Avaliação de Linha de Base",
        "Indian Usecases": "Casos de Uso na Índia",
      },
    },

    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  },
});

export default i18n;
